import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { logServerException } from 'appinsights/clientAppInsights';
import ProductOfferingsModuleCard from 'components/common/ProductOfferingsModuleCard';
import CardGrid from 'components/common/subcomponents/CardGrid';
import PleaseWait from '../common/PleaseWait';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { KitCard } from 'components/common/cms-kit';

const defaultErrorMessage =
  'An unexpected error has occured. Please try again.';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ProductOfferings = (props) => {
  const { customData, module } = props;

  console.warn(
    '..........................ProductOfferings module.fields: ',
    module.fields,
  );

  const theme = useTheme();

  const [canAccessModules, setCanAccessModules] = useState(false);
  const [modules, setModules] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const [showSeries, setShowSeries] = useState(true);

  useEffect(() => {
    let moduleArray = [];
    customData.mods &&
      customData.mods.length > 0 &&
      customData.mods.forEach((mod, i) => {
        if ((mod.seriesTitle = 'Well-Managed Schools')) {
          moduleArray.push(mod);
        }
      });
    setModules(moduleArray);
    setShowSeries(module.fields.showSeriesonLoad === 'true' ? true : false);
  }, [module, customData]);

  const MainFrame = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: 992px) {
      width: 100%;
      padding: 25px 0 25px 0;
    }
    @media screen and (max-width: 992px) {
      width: 99%;
      padding: 5px 0 5px 0;
    }
  `;

  const HeadingCardFrame = styled.div`
    background-color: transparent;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0 2em;
    @media screen and (min-width: 992px) {
      margin: 40px 150px;
    }
    @media screen and (max-width: 992px) {
      margin: 10px 20px;
    }
  `;

  const Container = styled.div`
    margin-top: 30px;
    padding-bottom: 50px;
    @media screen and (min-width: 992px) {
      width: 100%;
    }
    @media screen and (max-width: 992px) {
      width: 99%;
    }
  `;

  const ProductName = styled.div`
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;
    color: ${theme.palette.common.black};
    @media screen and (min-width: 992px) {
      font-size: 1.25rem;
      line-height: 1.313rem;
    }
    @media screen and (max-width: 992px) {
      font-size: 1.425rem;
      line-height: 1.55rem;
    }
  `;

  const ShowSeriesLinkContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
  `;

  const ShowSeriesLink = styled.div`
    margin: 15px 0 -15px 0;
    font-weight: 600;
    cursor: pointer;
    @media screen and (min-width: 992px) {
      font-size: 1.1rem;
      line-height: 1.225rem;
    }
    @media screen and (max-width: 992px) {
      font-size: 1rem;
      line-height: 1.125rem;
    }
  `;

  const IntroductionBox = styled.div`
    background-color: ${theme.palette.secondaryLightBlue50.main};
    margin: 0;
  `;

  const IntroContainer = styled.div`
    @media screen and (min-width: 992px) {
      width: 100%;
      padding: 5px 15px 0 15px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    @media screen and (max-width: 992px) {
      width: 99%;
      padding: 5px 5px 10px 5px;
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
  `;

  const HeadingTextContainer = styled.div`
    @media screen and (min-width: 992px) {
      width: 90%;
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }
    @media screen and (max-width: 992px) {
      display: none;
    }
  `;

  const HeadingTextMobileContainer = styled.div`
    @media screen and (min-width: 992px) {
      display: none;
    }
    @media screen and (max-width: 992px) {
      width: 99%;
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }
  `;

  return (
    <MainFrame>
      <HeadingCardFrame>
        <Box
          sx={{
            width: '100%',
            ml: 'auto',
            mr: 'auto',
            maxWidth: {
              sm: '540px',
              md: '768px',
              lg: '1200px',
              xl: '1200px',
            },
          }}
        >
          <KitCard
            style={{
              width: '100%',
              paddingBottom: '30px',
            }}
          >
            <IntroductionBox>
              <IntroContainer>
                <ImageContainer
                  style={{
                    backgroundImage: `url(${module?.fields?.headingImage?.url})`,
                  }}
                ></ImageContainer>
                <HeadingTextContainer>
                  <ProductName>{module.fields.product}</ProductName>
                  <IntroText>{module.fields.description}</IntroText>
                </HeadingTextContainer>
              </IntroContainer>
              <HeadingTextMobileContainer>
                <ProductName>{module.fields.product}</ProductName>
                <IntroText>{module.fields.description}</IntroText>
              </HeadingTextMobileContainer>
            </IntroductionBox>
            <ShowSeriesLinkContainer>
              <ShowSeriesLink onClick={(e) => setShowSeries(!showSeries)}>
                {showSeries ? (
                  <span>{module.fields.hideSeriesText}</span>
                ) : (
                  <span>{module.fields.showSeriesText}</span>
                )}{' '}
                {showSeries ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              </ShowSeriesLink>
            </ShowSeriesLinkContainer>
            {showSeries && (
              <Container>
                <PleaseWait isLoading={isLoading} />
                <CardGrid style={{ margin: '-10px 10px -50px 10px' }}>
                  {modules?.map((m) => (
                    <ProductOfferingsModuleCard
                      key={m.contentID}
                      offering={m}
                      cardHeaderColor={module.fields.cardHeaderColor}
                      cardHeaderTabColor={module.fields.cardHeaderTabColor}
                      cardHeaderTextColor={module.fields.cardHeaderTextColor}
                    />
                  ))}
                </CardGrid>
              </Container>
            )}
          </KitCard>
        </Box>
      </HeadingCardFrame>
    </MainFrame>
  );
};

const resolveSeriesUrls = function (sitemap, posts) {
  let dynamicUrls = {};
  posts.forEach((post) => {
    Object.keys(sitemap).forEach((path) => {
      if (sitemap[path].contentID === post.contentID) {
        if (path.indexOf('well-managed-schools') > 0) {
          dynamicUrls[post.contentID] = path;
        }
      }
    });
  });
  return dynamicUrls;
};

// This is called during server-side rendering (not part of NextJS).
ProductOfferings.getCustomInitialProps = async ({
  agility,
  channelName,
  languageCode,
}) => {
  const api = agility;

  try {
    //get sitemap in order to get the dynamic urls
    let sitemap = await api.getSitemapFlat({
      channelName: channelName,
      languageCode,
    });

    // get modules
    let raw = await api.getContentList({
      referenceName: 'ntrwmsmodulelist',
      languageCode,
      contentLinkDepth: 2,
      // expandAllContentLinks: true,
      depth: 2,
      sort: 'fields.sortOrder',
      take: 50,
    });

    const dynamicUrls = resolveSeriesUrls(sitemap, raw.items);

    let mods = raw.items.map((mod) => {
      const url = dynamicUrls[mod.contentID];
      if (url == undefined) {
        console.log(
          '*** Failed to get url for ' +
            mod.contentID +
            '  ' +
            mod.fields.moduleName,
        );
      }
      mod.url = url;
      return mod;
    });

    return {
      mods,
    };
  } catch (error) {
    await logServerException(error);
    if (console) console.error(error);
  }
};

const ImageContainer = styled('div')(({ theme }) => ({
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  [theme.breakpoints.up('md')]: {
    width: '240px',
    aspectRatio: '2 / 1',
    borderRadius: '6px',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    maxWidth: '350px',
    aspectRatio: '2 / 1',
    borderRadius: '6px 0 0 6px',
  },
}));

const IntroText = styled('div')(({ theme }) => ({
  color: theme.palette.common.black,
  fontSize: '1.063rem',
  lineHeight: '1.75rem',
  '& li': {
    '&::before': {
      backgroundColor: '#000 !important',
    },
  },
  [theme.breakpoints.up('md')]: {
    marginBottom: '10px',
  },
  [theme.breakpoints.down('md')]: {
    marginBottom: '25px',
  },
}));

export default ProductOfferings;
